import React from "react"
import Link from "next/link"

import { useTranslation, useLanguageQuery } from "next-export-i18n"
const BookAppointment = () => {
  const { t } = useTranslation()
  const [query] = useLanguageQuery()
  return (
    <div className="w-full bg-white ">
      <div className="w-full bookAppointment  mx-auto px-6 py-32">
        <h1 className=" text-2xl md:text-4xl text-white font-semibold text-center pb-4">
          {t("speak_to_a_nurse_practitioner")}
        </h1>
        <div className="flex justify-center">
          <Link
            href={{
              pathname: t("register_for_a_phone_or_video_call_here.route"),
              query: query,
            }}
          >
            <a className=" text-center text-base md:text-lg font-semibold text-secondary hover:text-white bg-white transition-all hover:bg-secondary hover:shadow-lg rounded-full px-6 md:px-10 py-3.5 cursor-pointer">
              {t("register_for_a_phone_or_video_call_here.text")}
            </a>
          </Link>
        </div>
        <p className=" text-base md:text-lg font-medium text-center text-white pt-4">
          {t("or_call")} 1-800-409-3484
        </p>
      </div>
    </div>
  )
}

export default BookAppointment
